import { render } from "./storeTabbar.vue?vue&type=template&id=20d24704&scoped=true"
import script from "./storeTabbar.vue?vue&type=script&lang=js"
export * from "./storeTabbar.vue?vue&type=script&lang=js"

import "./storeTabbar.vue?vue&type=style&index=0&id=20d24704&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d24704"]])

export default __exports__